'use client';
import { createTheme } from '@mui/material/styles';
import { Theme } from '@mui/material';

import { PaletteOptions } from '@mui/material';
import { DeepPartial } from 'utility-types';

export type PalletConfig = Pick<
  PaletteOptions,
  'primary' | 'secondary' | 'background' | 'text'
>;

const sanitizeConfig = (
  config?: DeepPartial<PaletteOptions> | string,
): DeepPartial<PaletteOptions> | undefined => {
  if (!config || config === '') return undefined;

  const sanitized = Object.entries(config).reduce((acc, [key, value]) => {
    const processed =
      value !== null && typeof value === 'object' && !Array.isArray(value)
        ? sanitizeConfig(value as DeepPartial<PaletteOptions>)
        : value === ''
          ? undefined
          : value;

    if (processed !== undefined) {
      acc[key] = processed;
    }
    return acc;
  }, {} as any);

  return Object.keys(sanitized).length === 0 ? undefined : sanitized;
};

export const getDarkPalette = (config?: DeepPartial<PalletConfig>) => {
  return {
    mode: 'dark' as const,
    background: {
      default: '#242221',
      paper: '#474644',
    },
    text: {
      primary: '#fff',
      secondary: '#e3e3e3',
    },
    ...sanitizeConfig(config),
  } as PaletteOptions;
};

const getDarkTheme = (theme: Theme, config?: DeepPartial<PalletConfig>) => {
  return createTheme({
    ...theme,
    palette: {
      primary: theme.palette.primary,
      secondary: theme.palette.secondary,
      success: theme.palette.success,
      error: theme.palette.error,
      ...getDarkPalette(config),
    },
  });
};

export default getDarkTheme;
